var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ecartapi-hero"},[_c('img',{staticClass:"ecartapi-hero__banner",attrs:{"alt":"Ecart API","src":require("@/assets/images/auth/hero-ecart-api.svg")}})])
}]

export { render, staticRenderFns }